import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { awsSortedAccountsSelector } from "./awsSortedAccountsSelector";
import { nonDeletedAccountsCombiner } from "../../combiners/nonDeletedAccountsCombiner";

export const awsNonDeletedAccountsSelector = createDraftSafeSelector(
  [awsSortedAccountsSelector],
  nonDeletedAccountsCombiner,
);
